import { Reveal, SectionHead } from "../site/Motion";
import { BgVideo } from "../site/BgVideo";

const STEPS = [
  ["Compounding", "Controlled mixing of polymer, fillers and curatives for each grade."],
  ["Molding & curing", "Compression / transfer molding on hydraulic presses."],
  ["Finishing", "Deflashing, trimming and visual inspection of every lot."],
];

const Tile = ({ className = "", children, testId }) => (
  <Reveal className={className}>
    <div data-testid={testId} className="clip-corner group relative h-full min-h-[280px] overflow-hidden bg-[#0d121b]">{children}</div>
  </Reveal>
);

export const Infrastructure = () => (
  <section id="infrastructure" data-testid="infrastructure-section" className="noise relative bg-[#07090e] py-24 text-white md:py-32">
    <div className="grid-lines absolute inset-0 opacity-60" />
    <div className="container-x relative">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <SectionHead dark eyebrow="03 — Manufacturing & infrastructure" title={<>In-house. <span className="text-outline">End to end.</span></>}>
          From raw compound to packed dispatch, every stage runs under one roof — so tolerances, timelines and batch quality stay in our control.
        </SectionHead>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-12 md:auto-rows-[300px]">
        <Tile className="md:col-span-8" testId="infrastructure-bento-card-press">
          <img src="/media/factory_press.jpg" alt="Hydraulic compression molding press" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <span data-testid="machine-spec-badge" className="font-mono-x bg-[#0a6cff] px-2 py-1 text-[10px] uppercase tracking-widest">Molding shop</span>
            <h3 className="font-display mt-3 text-3xl font-extrabold uppercase md:text-4xl">Hydraulic compression presses</h3>
          </div>
        </Tile>
        <Tile className="md:col-span-4 md:row-span-2" testId="infrastructure-bento-card-video">
          <BgVideo testId="infrastructure-video" src="/media/process.mp4" poster="/media/process_poster.jpg" className="absolute inset-0 h-full w-full object-cover opacity-90" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-[#07090e]/10 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <span className="font-mono-x flex items-center gap-2 text-[10px] uppercase tracking-widest text-sky-300"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-500" /> Process clip</span>
            <h3 className="font-display mt-3 text-3xl font-extrabold uppercase">Tooling & machining</h3>
          </div>
        </Tile>
        <Tile className="md:col-span-4" testId="infrastructure-bento-card-lab">
          <img src="/media/factory_lab.jpg" alt="Rubber testing laboratory" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-transparent" />
          <h3 className="font-display absolute bottom-6 left-6 text-3xl font-extrabold uppercase">QA laboratory</h3>
        </Tile>
        <Tile className="md:col-span-4" testId="infrastructure-bento-card-process">
          <div className="flex h-full flex-col justify-between border border-slate-800 p-6">
            <p className="eyebrow text-sky-400">The line</p>
            <ol className="space-y-4">
              {STEPS.map(([t, d], i) => (
                <li key={t} className="flex gap-4">
                  <span className="font-mono-x text-xs text-sky-400">0{i + 1}</span>
                  <div><p className="font-semibold text-white">{t}</p><p className="text-xs leading-relaxed text-slate-400">{d}</p></div>
                </li>
              ))}
            </ol>
          </div>
        </Tile>
      </div>
    </div>
  </section>
);
